<template>
  <div class="subject">

    <div v-show="!show" class="select">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>加入企业</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="join">去加入</el-button>
        </div>
        <div class="h">
          企业已入驻平台，受邀加入
        </div>
        <div class="item">
          适用于企业已入驻平台，请联系企业管理员邀请加入企业，或输入企业邀请码申请加入企业
        </div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>创建企业</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="add">去创建</el-button>
        </div>
        <div class="h">
          企业未入驻平台，创建企业
        </div>
        <div class="item">
          适用于企业未入驻平台，创建企业需要提供相应资料，创建成功您将自动成为该企业管理员
        </div>
      </el-card>
    </div>
    <div v-show="show" class="form">
      <p class="back" @click="add"><i class="left"></i> 返回</p>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="ruleForm"
        label-width="150px"
        status-icon
      >
        <el-form-item label="行业类型：" prop="industryValue">
          <el-select v-model="ruleForm.industryValue" placeholder="请选择" style="width: 400px;">
            <el-option
              v-for="item in industryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业名称：" prop="enterpriseName">
          <el-input
            v-model="ruleForm.enterpriseName"
            autocomplete="off"
            class="input"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="creditCode">
          <el-input
            v-model="ruleForm.creditCode"
            autocomplete="off"
            class="input"
            placeholder="请输入统一社会信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人姓名：" prop="legalPersonName">
          <el-input
            v-model="ruleForm.legalPersonName"
            autocomplete="off"
            class="input"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业注册地：" prop="addressValue">
          <el-cascader
            v-model="ruleForm.addressValue"
            :options="addressOptions"
            :props="props"
            filterable
            placeholder="请选择企业注册地"
            style="width: 400px;"
            @change="cascaderChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="企业规模：" prop="scaleValue">
          <el-select v-model="ruleForm.scaleValue" placeholder="请选择" style="width: 400px;">
            <el-option
              v-for="item in scaleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              class="input">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业执照：" prop="file">
          <el-upload
            :action="upAction"
            :file-list="fileList"
            :headers="getToken"
            :limit="1"
            :on-error="error"
            :on-exceed="handleExceed"
            :on-success="success"
            accept=" .jpg, .jpeg, .png, .bmp, .pdf"
            class="upload-demo"
            multiple>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">上传营业执照照片或者扫描件
              信息需清晰可见，内容真实有效，不可做任何修改
              只支持.jpg .jpeg .png .bmp .pdf格式
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" class="next" type="primary" @click="submitForm('ruleForm')"
          >提交
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
import {allDivisionTree} from '@/api/public'
import {companyAdd, companyInvitationJoin} from '@/api/organization'
import {companyScaleList, industryTypeList} from '@/api/authority'

export default {
  name: "addEnterprise",
  data() {
    const industryProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择行业类型"))
      } else {
        callback()
      }
    };
    const enterpriseNameProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入企业名称"));
      } else {
        callback();
      }
    };
    const creditCodeProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入统一社会信用代码"));
      } else {
        callback();
      }
    };
    const legalPersonNameProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入法人姓名"));
      } else {
        callback();
      }
    };
    const addressProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择企业注册地"));
      } else {
        callback();
      }
    };
    const scaleProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择企业规模"));
      } else {
        callback();
      }
    };
    const fileProp = (rule, value, callback) => {
      if (this.fileList.length == 0) {
        callback(new Error("请上传营业执照"));
      } else {
        callback();
      }
    };

    return {
      submitLoading: false,
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
      upAction: this.$getImg + 'api/auth/img',
      addressOptions: [],
      show: false,
      scaleOptions: [],
      industryOptions: [],
      props: {value: 'id'},
      ruleForm: {
        industryValue: "",
        enterpriseName: "",
        creditCode: "",
        legalPersonName: "",
        addressValue: "",
        scaleValue: "",
      },
      fileList: [],
      rules: {
        industryValue: [{validator: industryProp, trigger: "blur"}],
        enterpriseName: [{validator: enterpriseNameProp, trigger: "blur"}],
        creditCode: [{validator: creditCodeProp, trigger: "blur"}],
        legalPersonName: [{validator: legalPersonNameProp, trigger: "blur"}],
        addressValue: [{validator: addressProp, trigger: "blur"}],
        scaleValue: [{validator: scaleProp, trigger: "blur"}],
        file: [{validator: fileProp, trigger: "blur"}]
      },
    };
  },
  mounted() {
    if (this.$route.params.source == 'personal') {
      if (this.$route.params.type == 'add') {
        this.show = true
      } else if (this.$route.params.type == 'join') {
        this.show = false

        this.$prompt('请输入企业邀请码,企业邀请码是由字母和数字组成的8位编码,可通过企业管理员获取', '加入企业', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^(?=.*[a-zA-Z0-9]).{8}$/,
          inputErrorMessage: '邀请码格式不正确'
        }).then(({value}) => {
          companyInvitationJoin({
            invitationCode: value
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.submitLoading = false
            } else {
              this.$alert('加入企业申请已提交，请等待企业管理员审批。', '提交成功', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$emit('addSuccess')
                }
              })
            }
          })
        }).catch(() => {

        })
      }
    }
    if (JSON.stringify(this.$route.params) != '{}') {
      console.log(this.$route.params)
    }

    allDivisionTree().then((response) => {
      this.addressOptions = response.data.data
      this.fors(this.addressOptions)
      // console.log(this.addressOptions)
    })
    industryTypeList().then((response) => {
      const a = [];
      response.data.data.forEach(e => {
        a.push({value: e.itemValue, label: e.itemText})
      })
      this.industryOptions = a
    })
    companyScaleList().then((response) => {
      const a = [];
      response.data.data.forEach(e => {
        a.push({value: e.itemValue, label: e.itemText})
      })
      this.scaleOptions = a
    })
  },
  methods: {
    cascaderChange(e) {
      console.log(e)
    },
    fors(v) {
      v.forEach((s) => {
        if (s.children.length == 0) {
          Reflect.deleteProperty(s, 'children')

        } else {
          this.fors(s.children)
        }
      })
    },
    add() {
      if (localStorage.getItem('peopleName')) {
        this.show = !this.show
      } else {
        this.$alert('请先完善个人信息', '提示', {
          confirmButtonText: '去完善',
        }).then(() => {
          this.$router.push({
            name: 'personal', params: {
              source: 'addEnterprise',
              type: 'add'
            }
          });
        }).catch(() => {

        })
      }
    },
    error(err) {
      console.log(err)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    success(response, file, fileList) {
      this.fileList = fileList
    },
    join() {
      if (localStorage.getItem('peopleName')) {
        this.$prompt('请输入企业邀请码,企业邀请码是由字母和数字组成的8位编码,可通过企业管理员获取', '加入企业', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^(?=.*[a-zA-Z0-9]).{8}$/,
          inputErrorMessage: '邀请码格式不正确'
        }).then(({value}) => {
          companyInvitationJoin({
            invitationCode: value
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.submitLoading = false
            } else {
              this.$alert('加入企业申请已提交，请等待企业管理员审批。', '提交成功', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$emit('addSuccess')
                }
              })
            }
          })
        }).catch(() => {

        })
      } else {
        this.$alert('请先完善个人信息', '提示', {
          confirmButtonText: '去完善',
        }).then(() => {
          this.$router.push({
            name: 'personal', params: {
              source: 'addEnterprise',
              type: 'join'
            }
          });
        }).catch(() => {

        })
      }
    },
    submitForm(formName) {
      this.submitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          companyAdd({
            industryType: this.ruleForm.industryValue,
            companyName: this.ruleForm.enterpriseName,
            countyCode: this.ruleForm.addressValue.slice(-1)[0],
            organizationCode: this.ruleForm.creditCode,
            companyScale: this.ruleForm.scaleValue,
            owner: this.ruleForm.legalPersonName,
            businesslicenseCodeUrl: this.fileList[0].response.data,
            isCreateAdmin: 1
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.submitLoading = false
            } else {
              this.$alert('企业创建已提交审核，1-3工作日系统管理员会审核完成。', '提交成功', {
                confirmButtonText: '确定',
                callback: action => {
                  this.add(action)
                  this.submitLoading = false
                  this.ruleForm = {
                    industryValue: "",
                    enterpriseName: "",
                    creditCode: "",
                    legalPersonName: "",
                    addressValue: "",
                    scaleValue: "",
                  }
                }
              })
            }
          })
        } else {
          this.submitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.subject {
  .select {
    display: flex;
    flex-direction: column;
    align-items: center;

    .box-card {
      margin-top: 80px;
      text-align: left;
      width: 700px;

      .h {
        font-size: 24px;
        margin-bottom: 10px;
      }

      .item {
        font-size: 16px;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .next {
      border-radius: 4px;
      background-color: rgba(0, 123, 211, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      height: 50px;
      border-color: #3a62d7;
      width: 300px;
    }

    .ruleForm {
      margin-left: 100px;

      .input {
        width: 400px;
      }
    }

    .back {
      cursor: pointer;
      width: 376px;
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
      text-align: left;

      i {
        border: 3px solid black;
        border-width: 0px 1px 1px 0px;
        display: inline-block;
        padding: 5px;
      }

      .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }
  }
}
</style>
